import { CartUpdateEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

/* ---------------------------------------------
   CONFIG
---------------------------------------------- */

const MERGE_ENABLED = true;
let isMergingCart = false;

/* ---------------------------------------------
   AUTO PATCH CART API CALLS
---------------------------------------------- */

(function patchCartRequests() {

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {

    const response = await originalFetch.apply(this, args);

    const url = args[0];

    if (
      MERGE_ENABLED &&
      typeof url === 'string' &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      )
    ) {
      setTimeout(() => {
        handleCartMerge();
      }, 150);
    }

    return response;
  };

})();

/* ---------------------------------------------
   MAIN MERGE LOGIC
---------------------------------------------- */

async function handleCartMerge() {

  if (isMergingCart) return;

  isMergingCart = true;

  try {

    const cart = await fetch('/cart.js').then(r => r.json());

    const variantMap = {};
    const updates = {};
    // console.log("cart.items", cart.items);
    cart.items.forEach(item => {
      if (!variantMap[item.variant_id]) {
        variantMap[item.variant_id] = [];
      }
      variantMap[item.variant_id].push(item);
    });
    // console.log("variantMap", variantMap);
    Object.values(variantMap).forEach(items => {

      if (items.length <= 1) return;

      let totalQty = 0;

      items.forEach(item => {
        totalQty += item.quantity;
      });

      const primary = items[0];

      updates[primary.key] = totalQty;

      items.slice(1).forEach(item => {
        updates[item.key] = 0;
      });

    });

    if (!Object.keys(updates).length) {
      isMergingCart = false;
      return;
    }
    // console.log("updates",updates);
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });

    await refreshCartDrawer(response);

  } catch (err) {
    console.error("Cart merge error:", err);
  }

  setTimeout(() => {
    isMergingCart = false;
  }, 300);
}

/* ---------------------------------------------
   PROPER THEME DRAWER REFRESH
---------------------------------------------- */

// import { CartUpdateEvent } from '@theme/events';

async function refreshCartDrawer(response) {

  const cartComponent = document.querySelector('cart-items-component');
  if (!cartComponent) return;

  const sectionId = cartComponent.dataset.sectionId;
  if (!sectionId) return;

  //   const body = JSON.stringify({
  //     sections: sectionId,
  //     sections_url: window.location.pathname,
  //   });

  //   const response = await fetch(
  //     Theme.routes.cart_change_url,
  //     fetchConfig('json', { body })
  //   );

  const parsed = await response.json(); // ← SAFE NOW

  document.dispatchEvent(
    new CartUpdateEvent({}, sectionId, {
      itemCount: parsed.item_count,
      source: 'cart-merge',
      sections: parsed.sections,
    })
  );
}

